module.exports = __webpack_public_path__ + "img/messages-2.18867ee7.svg";